import { SVG } from "@components/items/common/SVG";
import { ShadcnButton } from "@components/items/display/ShadcnButton";
import TranslatedText from "@components/items/display/TranslatedText";
import { Loader2 } from "lucide-react";

const SucessCreditPurchase = ({
  onSubmit,
  isLoading,
}: {
  onSubmit: () => void;
  isLoading: boolean;
}) => {
  if (isLoading)
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader2 className={`h-20 w-20 animate-spin dark:text-[#64A6E1]`} />
      </div>
    );
  return (
    <div className="flex h-full flex-col gap-2 bg-white p-0 dark:bg-[#010D19]">
      <div className="flex flex-col items-center justify-center text-center md:gap-4 xl:gap-5">
        <SVG
          src="/assets/icons/success-replacement.svg"
          className="max-md:w-[120px]"
        />
        <TranslatedText
          text="full-books.success-purchase"
          className="text-[40px] font-bold text-primary dark:text-[#64A6E1]"
        />
        <TranslatedText
          text="full-books.balance-description"
          className="line-clamp-3 px-16 text-[20px] font-normal leading-8 text-[#575757] dark:text-[#91949C]"
        />
      </div>
      <ShadcnButton
        className="mt-auto !flex w-full items-center justify-center gap-1 bg-primary px-6 py-7 text-[20px] font-medium text-white hover:bg-primary hover:opacity-85 dark:bg-[#64A6E1] dark:text-[#010D19] dark:hover:bg-[#64A6E1]"
        onClick={onSubmit}
      >
        <TranslatedText text="full-books.continue" />
      </ShadcnButton>
    </div>
  );
};

export default SucessCreditPurchase;
